<template lang="pug">
v-dialog(
  persistent,
  v-model="dialog",
  :max-width="maxWidth",
)
  v-card
    v-card-title
      v-icon fas fa-{{ icon }}
      span.headline.ml-2 {{ headerText }}
      v-spacer
      v-icon.px-1(@click="$emit('close')") fas fa-times
    v-divider
    template(v-if="noSpace")
      slot(name="body")
    template(v-else)
      v-card-text.pb-0
        v-container
          slot(name="body")
    v-divider
    v-card-actions.py-3.px-6
      slot(name="footer")
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },

    headerText: {
      type: String,
      required: true,
    },

    dialog: {
      type: Boolean,
      default: false,
    },

    maxWidth: {
      type: Number,
      default: 600,
    },

    noSpace: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
